import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { IUIProfileService } from 'bi-interfaces/lib/interfaces/IUIProfileService';
import { IColumns, IScreen } from 'bi-interfaces';
import { UserUIProfile } from '../models/UserUIProfile';

@Injectable({
  providedIn: 'root'
})
export class UiProfileService implements IUIProfileService {

  public UserUIProfile: UserUIProfile = new UserUIProfile();

  public IsUserUIProfileFilled: boolean = false;
  public UserUIProfileFilledSubject = new Subject<void>()
  public UserUIProfileFilled$ = this.UserUIProfileFilledSubject.asObservable();


  private recentPageSubject = new Subject<IScreen>();
  recentPage$ = this.recentPageSubject.asObservable();

  private saveColumnLayoutSubject = new Subject<any>();
  saveColumnLayout$ = this.saveColumnLayoutSubject.asObservable();

  private saveColumnsConfigSubject = new Subject<any>();
  saveColumnsConfig$ = this.saveColumnsConfigSubject.asObservable();

  private favoriteScreenChangedSubject = new Subject<{isFavorite: boolean,pageUrl:string}>();
  favoriteScreenChanged$ = this.favoriteScreenChangedSubject.asObservable();

  constructor() { 
  }

  emitSaveColumnLayout(layoutColumns: number | null){
    this.saveColumnLayoutSubject.next({LayoutColumns: layoutColumns})
  }
  
  emitSaveColumnsConfig(gridDomId: string, columns: IColumns[]){
    this.saveColumnsConfigSubject.next({GridDomId: gridDomId, Columns: columns})
  }

  emitrecentPage(page: IScreen){
    this.recentPageSubject.next(page);
  }

  emitfavoriteScreenChanged(_isFavorite: boolean,_pageUrl:string = ''){
    this.favoriteScreenChangedSubject.next({isFavorite: _isFavorite, pageUrl:_pageUrl});
  }

}